const tagMatch=(tags, sub)=> {
  const tags_ = Array.isArray(tags) ? tags : tags.nodes;
  const matched = tags_ && tags_.filter(tag=>  (tag?.name ? tag.name : tag)===sub)
  return matched
}

export {tagMatch}
